export default "__VITE_ASSET__7SPx2VA9__"